export default "__VITE_ASSET__CifmOIbu__"